import {version} from '../package.json'

export const config = {
    mantainance: false,
    dev: false,
    bundle: "com.rhubbit.tcs",
    version: "2.0.6",
    acceptApiVersion: "2.0.0", //'2.0.0', 
    refreshTokenAdvance: 300, //seconds before expire
    apiKey: "c17cd389-d857-11ed-a15f-96000211878b",
    baseurl: "https://tcs-api.rhubbit.com",
    defaultLanguage: { code: "it", label: "Italian" },
    languages: [
        { code: "gb", label: "English" },
        { code: "it", label: "Italian" },
    ],
    tab_channel: {
        device: "com.rhubbit.tcs/device",
        mainTab: "com.rhubbit.tcs/main-tab"
    },
    push_notification: {
        enabled: false,
        apiKey: "xxx",
        config: {  // WARNING: Remember to copy this params in /public/firebase-messaging-sw.js
            apiKey: "...",
            authDomain: "...",
            projectId: "...",
            storageBucket: "...",
            messagingSenderId: "...",
            appId: "...",
            measurementId: "..."
        }
    },
    instance: {
        id: "multicedi", // id: "multicedi",
        name: "Total control <b>STORE</b>",
        name_notag: "Total control STORE"
    },
    restError: {
        BadRequest: "1000",
        PreconditionFailed: "6000",
        Forbidden: "8000",
    }
};